// Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { useEffect } from 'react';
import { FormControl, Select, MenuItem, ListItemText, CircularProgress } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { useGetApi } from '../data/hooks/api';
import { RESOURCE_SERVER_URLS } from '../data/configs/spl-config';

interface ABTTeamFilterSelectProps {
    selectedTeam: string | null;
    onTeamChange: (team: string | null) => void;
}

export const ABTTeamFilterSelect: React.FC<ABTTeamFilterSelectProps> = ({ selectedTeam, onTeamChange }) => {
    const { data: teams, loading, getApiData } = useGetApi<string[]>({
        url: `${RESOURCE_SERVER_URLS[0]}/abt-teams`
    });

    useEffect(() => {
        getApiData();
    }, []);

    const handleChange = (event: SelectChangeEvent<string>) => {
        onTeamChange(event.target.value || null);
    };

    return (
        <FormControl sx={{ m: 1, width: 220 }} size="small">
            <Select
                value={selectedTeam || ''}
                onChange={handleChange}
                displayEmpty
                disabled={loading}
                renderValue={(selected) => loading ? 'Loading...' : (selected || 'All Teams')}
            >
                <MenuItem value=""><ListItemText primary="All Teams" /></MenuItem>
                {loading && (
                    <MenuItem disabled>
                        <CircularProgress size={14} sx={{ mr: 1 }} /> Loading...
                    </MenuItem>
                )}
                {(teams ?? []).map((t) => (
                    <MenuItem key={t} value={t}><ListItemText primary={t} /></MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
